module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-b91d376b.woff2";